import __request__ from "routing/request";
export function retrieve(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.views/views/search/messages", JSONbody, {}, {
    "Accept": ["text/csv"]
  }, requestOptions);
}
export function retrieveForExportJob(exportJobId, filename, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.views/views/search/messages/job/${exportJobId}/${filename}`, null, {}, {
    "Accept": []
  }, requestOptions);
}
export function retrieveForSearch(searchId, Optionaloverrides, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.views/views/search/messages/${searchId}`, Optionaloverrides, {}, {
    "Accept": ["text/csv"]
  }, requestOptions);
}
export function retrieveForSearchType(searchId, searchTypeId, Optionaloverrides, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.views/views/search/messages/${searchId}/${searchTypeId}`, Optionaloverrides, {}, {
    "Accept": []
  }, requestOptions);
}
